const en = {
  common: {
    appName: "Letstest",
    panel: "Panel",
    loading: "Loading",
    pleaseWait: "Please wait",
    summary: "Summary",
    visibility: "Visibility",
    status: "Status",
    creator: "Creator",
    contact: "Contact",
    operations: "Operations",
    quickAccess: "Quick access to project modules",
    manage: "Manage",
    values: "Values",
    noComment: "No comment",
    noEnvironment: "No environment",
    typeLabel: "Type",
    brandLabel: "Brand",
    systemLabel: "System",
    nameLabel: "Name",
    emailLabel: "Email",
    bioLabel: "Bio",
    save: "Save",
    add: "Add",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    cancel: "Cancel",
    create: "Create",
    confirm: "Confirm",
    close: "Close",
    clearFilters: "Clear filters",
    customize: "Customize",
    viewFile: "View file",
    remove: "Remove",
    idLabel: "Id",
    all: "All",
    actions: "Actions",
    createdAction: "create",
    updatedAction: "update",
    createdResult: "created",
    updatedResult: "updated",
    openLabel: "Open {{label}}",
    templateLabel: "Template",
    environmentLabel: "Test environment",
    testScenarioLabel: "Test scenario",
    testCaseLabel: "Test case",
    executionDeviceLabel: "Execution device",
    selectValue: "Select a value",
    selectTemplate: "Select a template",
    selectDevice: "Select a device",
    selectEnvironment: "Select an environment",
    selectScenario: "Select a test scenario",
    selectCustomField: "Select a custom field",
    columnType: "Column type",
    attention: "Attention!",
    selectTemplateWarning: "Select the desired template to fill in.",
    selectDeviceWarning: "Select the execution device.",
    processError: "Unable to process request, try again",
    nameRequired: "Name is required",
    emailRequired: "Email is required",
    userAvatar: "User avatar",
    modelLabel: "Model",
    osLabel: "Operating system",
    descriptionLabel: "Description",
    typeRequired: "Type is required",
    brandRequired: "Brand is required",
    modelRequired: "Model is required",
    systemRequired: "Operating system is required",
    descriptionRequired: "Description is required",
    idRequired: "Id is required",
    dueDateLabel: "Due date",
    selfHosted: "Self-hosted",
    minutesLabel: "Minutes",
    hoursLabel: "Hours",
  },
  commom: {
    continue: "Continue",
  },
  profile: {
    title: "Profile",
    viewTitle: "View profile",
    editTitle: "Edit profile",
    userInfo: "User information",
    yourData: "Your data",
    mySkills: "My skills",
    myDevices: "My devices",
    updateSkills: "Update skills and certifications",
    manageExecutionEnvironments: "Manage execution environments",
    updateSuccess: "Profile updated successfully.",
    updateError: "Unable to update profile, try again.",
  },
  devices: {
    header: "Devices",
    newTitle: "New device",
    addButton: "Add device",
    searchLabel: "Search devices",
    searchPlaceholder: "Brand, model, or system",
    addSuccess: "Device added successfully.",
    addError: "Unable to add device, try again",
    deleteSuccess: "Device deleted successfully.",
    deleteError: "Unable to delete device, try again",
    empty: "No devices found.",
    myTitle: "My devices",
    loadError: "Unable to load devices.",
  },
  habilities: {
    header: "Skills",
    newTitle: "New skill",
    addButton: "Add skill",
    searchLabel: "Search skills",
    searchPlaceholder: "Search skills...",
    addSuccess: "Skill added successfully.",
    addError: "Unable to add skill, try again",
    descriptionLabel: "Description",
    descriptionRequired: "Description is required",
    deleteSuccess: "Skill deleted successfully.",
    deleteError: "Unable to delete skill, try again",
    empty: "No skills found.",
    myTitle: "My skills",
    loadError: "Unable to load skills.",
  },
  reports: {
    averageTitle: "Average ratings",
    loadingList: "Loading test case execution reviews...",
    emptyList: "No reviews found",
    ratedBy: "Rated by",
    situation: "Status",
    comment: "Comment",
    typeLabel: "Type",
    scoreLabel: "Score",
    commentLabel: "Comment",
    idLabel: "# {{id}}",
    ratedByLabel: "Rated by",
    situationLabel: "Status",
    commentPrefix: "Comment: {{comment}}",
    rateTitle: "Rate",
    createSuccess: "Review created successfully",
    createError: "Unable to create review, try again",
    typeRequired: "Type is required",
    scoreRequired: "Score is required",
    commentRequired: "Comment is required",
    listTitle: "Execution reviews # {{id}}",
    searchLabel: "Search by comment",
    searchPlaceholder: "Search by comment...",
    loadError: "Unable to load reviews",
  },
  projectOverview: {
    pageTitle: "Overview",
    testScenariosTitle: "Test Scenarios",
    reportTitle: "Project report",
    issuedOn: "Issued on {{date}}",
    total: "Total: {{total}}",
    scenarioLabel: "Scenario {{index}}",
    caseLabel: "Case {{index}}",
    executionLabel: "Execution {{index}} · #{{id}}",
    loadError: "Unable to load project.",
    exportPdf: "Export as PDF",
  },
  templates: {
    selectType: "Select template type",
    definitionLegend: "Template definition",
    viewTitle: "View template",
    editTitle: "Customize template",
    minRowRequired: "At least one row is required for confirmation.",
    createSuccess: "Template created successfully",
    createError: "Unable to create template, try again",
    listTitle: "Templates",
    loadError: "Unable to load templates.",
    searchLabel: "Search by name",
    searchPlaceholder: "Search by name...",
    createNew: "Create new",
    loadingList: "Loading project templates...",
    emptyList: "No templates found",
  },
  tags: {
    activeGroup: "Active",
    archivedGroup: "Archived",
    addValue: "Add value",
    formTitle: "Custom field",
    minValueRequired: "At least one value is required.",
    saveSuccess: "Custom field {{action}} successfully",
    saveError: "Unable to {{action}} custom field, try again",
    unexpectedError: "Unexpected error",
    commentLabel: "Comment",
    visibilityLabel: "Visibility",
    visibilityRequired: "Status is required",
    selectSituation: "Select the custom field status",
    helpCommentaryLabel: "Help comment",
    listTitle: "Custom Fields",
    loadError: "Unable to load custom fields.",
    searchLabel: "Search by name",
    searchPlaceholder: "Search by name...",
    createNew: "Create new",
    loadingList: "Loading project custom fields...",
    emptyList: "No custom fields found",
  },
  environment: {
    listTitle: "Test environments",
    loadError: "Unable to load test environments.",
    searchLabel: "Search by name",
    searchPlaceholder: "Search by name...",
    createNew: "Create new",
    loadingList: "Loading project test environments...",
    emptyList: "No test environments found",
    formEditTitle: "Edit",
    formCreateTitle: "Create",
    saveChanges: "Save changes",
    createEnvironment: "Create environment",
    updateSuccess: "Environment updated successfully",
    updateError: "Unable to update environment, try again",
    createSuccess: "Environment created successfully",
    createError: "Unable to create environment, try again",
    situationRequired: "Status is required",
    descriptionLabel: "Description/Access",
    descriptionRequired: "Description/Access is required",
  },
  testScenario: {
    listTitle: "Test Scenarios",
    definitionLegend: "Test Scenario definition:",
    pageTitle: "Test Scenario",
    noTemplatesInfo: "There are no templates for test scenario definition, please create at least one.",
    minRowRequired: "At least one row is required for confirmation.",
    saveSuccess: "Test scenario {{action}} successfully",
    saveError: "Unable to {{action}} test scenario, try again",
    unexpectedError: "Unexpected error",
    templateRequired: "Template is required",
    loadError: "Unable to load test scenarios.",
    searchLabel: "Search by name",
    searchPlaceholder: "Search by name...",
    createNew: "Create new",
    loadingList: "Loading project test scenarios...",
    emptyList: "No test scenarios found",
    lockedByExecution: "This scenario has executions and cannot be edited.",
    viewCases: "View cases",
    approveAction: "Approve",
  },
  testCase: {
    listTitle: "Test Cases",
    definitionLegend: "Test Case definition:",
    pageTitle: "Test Case",
    noTemplatesInfo: "There are no templates for test case definition, please create at least one.",
    minRowRequired: "At least one row is required for confirmation.",
    saveSuccess: "Test case {{action}} successfully",
    saveError: "Unable to {{action}} test case, try again",
    unexpectedError: "Unexpected error",
    environmentRequired: "Test environment is required",
    testScenarioRequired: "Test scenario is required",
    templateRequired: "Template is required",
    loadError: "Unable to load test cases.",
    searchLabel: "Search by name",
    searchPlaceholder: "Search by name...",
    testerFilterLabel: "Filter by tester",
    createNew: "Create new",
    loadingList: "Loading project test cases...",
    emptyList: "No test cases found",
    scenarioButton: "Scenario",
    executionsButton: "Executions",
    testButton: "Test",
    noScenario: "No scenario",
    lockedByExecution: "This test case has executions and cannot be edited.",
    assignAction: "Assign testers",
    assignTitle: "Assign testers",
    assignHelp: "Choose the testers that will execute this test case.",
    assignSearchLabel: "Search tester",
    assignSearchPlaceholder: "Name or email",
    assignConfirm: "Confirm assignment",
    assignSuccess: "Testers assigned successfully",
    assignError: "Unable to assign testers, try again",
    assignLoadError: "Unable to load testers",
    assignEmpty: "No testers found",
    awaitingAssignment: "Awaiting assignment",
    assignedStatus: "Assigned",
    viewAssignment: "View assignment",
    openExecutionButton: "Execute",
    statusFilterLabel: "Execution status",
    statusIdle: "Not started",
    statusRunning: "In progress",
    statusPaused: "Paused",
    statusFinished: "Finished",
    viewList: "List",
    viewKanban: "Kanban",
    emptyStatusColumn: "No test cases in this status",
    kanbanUnassigned: "Unassigned",
    kanbanNotStarted: "Not started",
    kanbanInProgress: "In progress",
    kanbanPaused: "Paused",
    kanbanDone: "Done",
    kanbanEmpty: "No test cases",
    startTestButton: "Start test",
    pauseTestButton: "Pause",
    pauseTestConfirm: "Do you want to pause this test?",
    pauseTestSuccess: "Test paused successfully.",
    resumeTestButton: "Resume",
    reportTestButton: "Report test",
    startTestError: "Unable to start test. Please try again.",
    pauseTestError: "Unable to pause test. Please try again.",
    resumeTestError: "Unable to resume test. Please try again.",
  },
  testExecution: {
    sessionTitle: "Execute test case",
    elapsedLabel: "Elapsed so far: {{time}}",
    startSuccess: "Test started successfully.",
    pauseSuccess: "Test paused successfully.",
    resumeSuccess: "Test resumed successfully.",
    finishSuccess: "Test finished, proceed to report.",
    reportLegend: "Report Test Case execution:",
    pageTitle: "Run Test Case",
    executeTitle: "Execute test case",
    testCaseRequired: "Test case is required",
    deviceRequired: "Device is required",
    templateRequired: "Template is required",
    reportButton: "Report execution",
    noTemplatesInfo: "There are no execution templates for this project, please create at least one.",
    reportSuccess: "Execution reported successfully.",
    reportError: "Unable to report execution, try again.",
    listTitle: "Test case executions #{{id}}",
    loadError: "Unable to load test case executions: {{error}}",
    searchLabel: "Search by #",
    searchPlaceholder: "Search by #...",
    loadingList: "Loading test case executions...",
    emptyList: "No executions found for this test case",
    testedByLabel: "Tested by",
    executionTimeLabel: "Execution time",
    executionTimeHint: "Suggested: {{time}} (you can adjust)",
    executionTimePlaceholder: "Ex: 1:15",
    executionTimeFormatHint: "Format: H:MM (hours:minutes) or minutes",
    executionTimeInvalid: "Enter a valid time. Ex: 1:15 or 45",
    startError: "Unable to start the test. Please try again.",
    pauseError: "Unable to pause the test. Please try again.",
    resumeError: "Unable to resume the test. Please try again.",
    finishError: "Unable to finish the test. Please try again.",
    deviceLabel: "Device",
    evaluateButton: "Review",
    ratingsButton: "Reviews",
  },
  fileUpload: {
    uploading: "Uploading file {{current}} of {{total}}...",
    uploadedSuccess: "Files uploaded successfully:",
    uploadError: "Unable to upload file: {{error}}",
  },
  timer: {
    elapsed: "Elapsed time: {{time}}",
    continue: "Continue",
    start: "Start",
    finish: "Finish",
    pause: "Pause",
    resume: "Resume",
    reset: "Reset",
    recordScreen: "Record screen",
    recordError: "Unable to start recording:",
  },
  customTable: {
    editColumnTitle: "Edit column",
    contentPlaceholder: "Content",
    helpTextPlaceholder: "Help text",
    loadTagsError: "Unable to load tags:",
    typeLabel: "Column type",
    contentLabel: "Content",
    placeholderLabel: "Help text",
    tagLabel: "Custom field",
    typeHelpTitle: "Quick tip",
    typeHelpDescription: "Pick the right type to keep data organized and easy to read.",
    previewLabel: "Preview",
    previewHint: "This is only a preview of the field.",
    addRow: "Add row",
    addColumn: "Add column",
    duplicateRow: "Duplicate row",
    removeRow: "Remove row",
    duplicateColumn: "Duplicate column",
    removeColumn: "Remove column",
    editColumn: "Edit column",
    editLabelDefault: "Edit label",
    columnLabel: "Column {{index}}",
    fillPlaceholder: "Fill in the field",
    emptyValue: "No value",
    maxColumnsInfo: "Row cannot have more than {{count}} column(s)",
    minColumnsInfo: "Row must have at least {{count}} column(s)",
    minRowRequired: "At least one row is required",
    columnTypes: {
      label: "Label",
      text: "Short text",
      longText: "Long text",
      tag: "Custom field",
      list: "List",
      table: "Table",
      empty: "Empty space",
      file: "File",
      multipleFiles: "Multiple files",
    },
  },
  involvement: {
    acceptError: "Unable to accept involvement with the project.",
    rejectError: "Unable to reject involvement with the project.",
    removeError: "Unable to remove involvement with the project.",
    addMember: "Add member",
    addMemberTitle: "Link member to project",
    addMemberHelp: "Select organization members to link to this project.",
    addAction: "Add",
    loadMembersError: "Unable to load organization members.",
    addSuccess: "Member linked successfully.",
    addError: "Unable to link member.",
    emptyMembers: "No members available to link.",
    creatorLabel: "Creator",
    accept: "Accept",
    reject: "Reject",
    cancelRequest: "Cancel request",
    pendingTitle: "Requests and invitations",
    loadError: "Unable to load involvements.",
    invitationsTitle: "Received invitations",
    invitationsHelp: "Invitations sent to you by project managers",
    invitationsLoadError: "Unable to load invitations.",
    requestsTitle: "Sent requests",
    requestsHelp: "Participation requests sent by you",
    requestsLoadError: "Unable to load requests.",
    emptyList: "No involvements found.",
    ownerLoadError: "Unable to load involvements.",
    inviteEmailLabel: "Invite by email",
    inviteEmailTitle: "Invite by email",
    inviteEmailHelp: "Enter the user's email to send an invite.",
    inviteByEmail: "Invite by email",
    inviteSearch: "Search users",
    invitePlaceholder: "User email for invite",
    inviteMissingEmail: "Enter an email to send the invite.",
    inviteSuccess: "Invitation sent.",
    inviteError: "Unable to send invitation.",
    inviteButton: "Invite",
    inviteModalTitle: "Invite user",
    inviteModalHelp: "Search by name, email, skills, or devices to send invites.",
    inviteSearchError: "Error while searching users.",
    searchLabel: "Search user",
    searchPlaceholder: "Name or email",
    habilityLabel: "Skill",
    habilityPlaceholder: "e.g. Cypress, QA, English",
    habilityTypeLabel: "Skill type",
    deviceTypeLabel: "Device type",
    deviceBrandLabel: "Device brand",
    deviceBrandPlaceholder: "e.g. Apple, Samsung",
    deviceModelLabel: "Device model",
    deviceModelPlaceholder: "e.g. iPhone 14, Galaxy S23",
    deviceSystemLabel: "Device system",
    deviceSystemPlaceholder: "e.g. iOS, Android, Windows",
    searchResults: "Search results",
    emptySearch: "No users found with these filters.",
    loadingList: "Loading involvements...",
    emptyReceived: "No applications received",
    emptyForSituation: "No project involvements for the selected status",
    viewProfile: "View profile",
  },
  nav: {
    dashboard: "Dashboard",
    findProjects: "Find projects",
    manageProjects: "Manage projects",
    testProjects: "Test projects",
    billing: "Billing",
    apiKeys: "API Keys",
    webhooks: "Webhooks",
    admin: "Admin",
    adminSubscriptions: "Subscriptions",
    myOrganizations: "My organizations",
    requestsInvites: "Requests and invites",
    invitations: "Invitations",
    requests: "Requests sent",
    orgInvites: "Organization invites",
    myProfile: "My profile",
    notifications: "Notifications",
    notificationsEmpty: "No notifications yet",
    viewAllNotifications: "View all notifications",
    tools: "Tools",
    toolsRecordScreen: "Record screen",
    toolsRecordingStarted: "Recording started.",
    toolsRecordingError: "Unable to start recording.",
    toolsChecklist: "Quick checklist",
    toolsChecklistTitle: "Quick checklist",
    toolsChecklistPlaceholder: "Add item (e.g. validate data)",
    toolsChecklistAdd: "Add",
    toolsChecklistEmpty: "No checklist items yet.",
    toolsChecklistDefaultEnvironment: "Confirm test environment",
    toolsChecklistDefaultScenario: "Review scenario and steps",
    toolsChecklistDefaultData: "Validate input data",
    toolsChecklistDefaultEvidence: "Capture evidence",
    toolsChecklistDefaultNotes: "Register notes",
    markAllRead: "Mark all read",
    logout: "Sign out",
    logoutSuccess: "Signed out",
  },
  projects: {
    operationsTitle: "Operations",
    operationsSubtitle: "Quick access to project modules",
    managersLabel: "Managers",
    testersLabel: "Testers",
    testScenariosLabel: "Test Scenarios",
    testCasesLabel: "Test Cases",
    customFieldsLabel: "Custom Fields",
    templatesLabel: "Templates",
    environmentsLabel: "Environments",
    overviewLabel: "Overview",
    notificationsLabel: "Notifications",
    loadError: "Unable to load project.",
    detailTitle: "Project details",
    ownerTitle: "Manage projects",
    ownerHelp: "Projects you are responsible for managing",
    testerTitle: "Test projects",
    testerHelp: "Projects you are responsible for testing",
    searchLabel: "Search by name",
    searchPlaceholder: "Search by name...",
    createNew: "Create new",
    loadingOwnerList: "Loading your projects...",
    emptyOwnerList: "No projects found",
    editAria: "Edit project",
    roleOwner: "Owner",
    roleManager: "Manager",
    loadListError: "Unable to load projects.",
    formEditTitle: "Edit",
    formCreateTitle: "Create",
    saveChanges: "Save changes",
    createProject: "Create project",
    updateSuccess: "Project updated successfully",
    updateError: "Unable to update project, try again",
    createSuccess: "Project created successfully",
    createError: "Unable to create project, try again",
    processError: "Unable to process request, try again",
    approvalTitle: "Approval workflow",
    approvalEnabled: "Enable approval workflow",
    approvalScenarioEnabled: "Require approval for test scenarios",
    approvalTestCaseEnabled: "Require approval for test cases",
    visibilityRequired: "Visibility is required",
    visibilityPlaceholder: "Select project visibility",
    public: {
      title: "Find projects",
      help: "Browse public projects and request access as a tester",
      createProject: "Create my project",
      invitations: "Invitations",
      requests: "Requests sent",
      searchPlaceholder: "Search by name...",
      loading: "Loading your projects...",
      empty: "No projects found",
      apply: "Request access",
      applySuccess: "Participation request sent",
      applyError: "Unable to send request, try again",
      loadError: "Unable to load projects",
      creatorLabel: "Creator",
    },
  },
  notifications: {
    settingsTitle: "Notification settings",
    settingsSaved: "Settings saved successfully.",
    settingsError: "Unable to save settings.",
    listTitle: "Notifications",
    filterAll: "All",
    filterUnread: "Unread",
    emptyList: "No notifications found",
    markRead: "Mark as read",
    channelsTitle: "Channels",
    channelInApp: "In-app notifications",
    channelEmail: "Email notifications",
    eventsTitle: "Critical events",
    executionRejected: "Execution rejected",
    inviteReceived: "Invite received",
    inviteAccepted: "Invite accepted",
    deadlineExceeded: "Deadline exceeded",
    deadlineConfigTitle: "Deadline alerts",
    deadlineWarning: "Warn before deadline",
    deadlineWarningDays: "Days in advance",
  },
  billing: {
    title: "Billing",
    subtitle: "Manage your subscription and usage.",
    settingsHelp: "Review subscription status and limits.",
    currentPlan: "Current plan",
    changePlan: "Change plan",
    manageBilling: "Manage billing",
    plansTitle: "Plans",
    plansSubtitle: "Choose the best plan for your organization.",
    planFree: "Free",
    plan_free: "Free",
    plan_pro: "Pro",
    plan_enterprise: "Enterprise",
    freePrice: "Free",
    priceMonthly: "R$ {{value}} / month",
    choosePlan: "Choose plan",
    loadError: "Unable to load billing data.",
    checkoutError: "Unable to start checkout.",
    portalError: "Unable to open billing portal.",
    disabled: "Billing is disabled for this environment.",
    usageTitle: "Usage and limits",
    unlimited: "Unlimited",
    apiAccess: "API access",
    apiNoAccess: "No API access",
    webhooksCount: "{{count}} webhooks",
    webhooksUnlimited: "Unlimited webhooks",
    auditLogsDays: "Audit logs: {{count}} days",
    auditLogsUnlimited: "Audit logs: unlimited",
    metricSeats: "Members",
    metricProjects: "Projects",
    metricTestCases: "Test cases",
    metricStorage: "Storage",
    metricExecutions: "Test executions",
    limitTitle: "Limit reached",
    limitSubtitle: "Upgrade to keep going",
    limitDescription: "You reached a plan limit for this action.",
    limitMetric: "{{metric}}: {{current}} / {{limit}}",
    limitIncludesInvites: "Includes pending invites: {{pending}}",
    upgradeAction: "See plans",
    successTitle: "Payment confirmed",
    successSubtitle: "Your plan has been updated.",
    backToBilling: "Back to billing",
  },
  webhooks: {
    title: "Webhooks",
    subtitle: "Configure notifications for system events.",
    listTitle: "Your Webhooks",
    create: "Create Webhook",
    empty: "No webhooks configured.",
    urlRequired: "URL is required.",
    eventsRequired: "Select at least one event.",
    createSuccess: "Webhook created successfully.",
    createError: "Failed to create webhook.",
    deleteSuccess: "Webhook removed successfully.",
    deleteError: "Failed to remove webhook.",
    updateSuccess: "Webhook updated successfully.",
    updateError: "Failed to update webhook.",
    confirmDelete: "Are you sure you want to remove this webhook?",
    loadError: "Failed to load webhooks.",
    noAccess: "Webhooks not available on your plan.",
    copied: "Copied to clipboard.",
    newWebhook: "New Webhook",
    webhookCreated: "Webhook Created",
    createTitle: "Create new Webhook",
    copyWarning: "Copy the secret below. It will not be shown again.",
    urlLabel: "Destination URL",
    eventsLabel: "Events",
    active: "Active",
    inactive: "Inactive",
    enable: "Enable",
    disable: "Disable",
    regenerate: "Regenerate secret",
    confirmRegenerate: "Are you sure you want to regenerate the secret? The previous secret will be invalidated.",
    regenerateSuccess: "Secret regenerated and copied.",
    regenerateError: "Failed to regenerate secret.",
    viewDeliveries: "View deliveries",
    recentDeliveries: "Recent deliveries",
    noDeliveries: "No deliveries recorded.",
    deliveriesError: "Failed to load deliveries.",
    limit: "{{current}} of {{max}} webhooks",
    events: {
      "test_execution.created": "Test execution created",
      "test_execution.reported": "Test execution reported",
      "report.created": "Report created",
      "test_case.created": "Test case created",
      "test_case.updated": "Test case updated",
      "test_scenario.created": "Test scenario created",
      "involvement.accepted": "Invitation accepted",
    },
  },
  dashboard: {
    pageTitle: "Dashboard",
    filtersTitle: "Global filters",
    filtersSubtitle: "Refine project insights",
    keyMetricsTitle: "Key metrics",
    executedCases: "Executed cases",
    coverageRate: "Case coverage",
    pendingReports: "Pending reviews",
    lastActivity: "Last activity",
    lastActivityEmpty: "No activity",
    qualitySignalTitle: "Quality signal",
    qualitySignalLabel: "Rejection level",
    qualitySignal: {
      low: "Low",
      medium: "Moderate",
      high: "High",
    },
    qualitySignalValue: "{{value}}% rejections",
    actionItemsTitle: "Priority actions",
    actionItemsEmpty: "No critical actions right now",
    actionPendingReports: "{{count}} executions waiting for review",
    actionLowCoverage: "Coverage below target ({{rate}}%)",
    actionHotspot: "Hotspot scenario: {{name}} ({{rate}}% failures)",
    actionNoExecutions: "No executions in the selected period",
    actionNoReviews: "No reviews recorded yet",
    projectLabel: "Project",
    scenarioLabel: "Scenario",
    testerLabel: "Tester",
    statusLabel: "Status",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    emptyProjects: "No projects available",
    overviewTitle: "Project overview",
    totalScenarios: "Total scenarios",
    totalManagers: "Total managers",
    totalTesters: "Total testers",
    totalCases: "Total cases",
    totalExecutions: "Total executions",
    totalReports: "Total reviews",
    approvalRate: "Approval rate",
    approvals: "Approvals",
    rejections: "Rejections",
    averageScore: "Average score",
    rankingTitle: "Tester ranking",
    topLabel: "Top 5",
    emptyRanking: "Not enough data for ranking",
    failureRateTitle: "Failure rate by scenario",
    failureRateLabel: "failures",
    emptyScenarios: "No scenarios found",
    unknownTester: "Tester",
    dailyExecutionsTitle: "Daily executions",
    dailyExecutionsSubtitle: "Executions reported by testers",
    periodLabel: "Period",
    lastDays: "Last {{count}} days",
    chartSummary: "Chart summary",
    averagePerDay: "Average per day",
    averagePerDayProject: "Average per day (project)",
    executionsLabel: "executions",
    customRange: "Custom range",
    startDateLabel: "Start date",
    endDateLabel: "End date",
    invalidRange: "Invalid range",
    startDateBeforeProject: "Start date cannot be earlier than project creation",
    managerProjects: "My projects",
    testerProjects: "Tested projects",
    myOverviewTitle: "My work overview",
    myPerformanceTitle: "My performance",
    myExecutions: "My executions",
    myApprovals: "My approvals",
    myRejections: "My rejections",
    myAverageScore: "My average score",
    failureRateMineTitle: "Failure rate for my tests",
  },
  enums: {
    device: {
      smartphone: "Smartphone",
      notebook: "Notebook",
      desktop: "Desktop",
      tablet: "Tablet",
      smartwatch: "Smartwatch",
    },
    project: {
      visibility: {
        public: "Public",
        private: "Private",
      },
      situation: {
        testing: "Testing",
        finished: "Finished",
        canceled: "Canceled",
      },
      type: {
        web: "Web",
        desktop: "Desktop",
        app: "App",
        hybrid: "Hybrid",
      },
    },
    involvement: {
      situation: {
        received: "Received",
        sent: "Sent",
        rejected: "Rejected",
        accepted: "Accepted",
      },
      type: {
        tester: "Tester",
        manager: "Manager",
      },
    },
    template: {
      type: {
        testScenarioDefinition: "Test scenario definition",
        testCaseDefinition: "Test case definition",
        testCaseExecution: "Test case execution",
      },
    },
    report: {
      type: {
        approved: "Approved",
        rejected: "Rejected",
      },
    },
    hability: {
      type: {
        experience: "Experience",
        certification: "Certification",
        course: "Course",
        language: "Language",
        softSkill: "Soft skill",
      },
    },
    environment: {
      situation: {
        operational: "Operational",
        inoperative: "Inoperative",
      },
    },
  },
  approval: {
    draft: "Draft",
    reviewed: "Reviewed",
    approved: "Approved",
  },
  auth: {
    loginTitle: "Access your account",
    loginSubtitle: "Keep your tests organized with clear execution flows.",
    loginTag1: "Software testing",
    loginTag2: "Guided workflow",
    loginTag3: "Clear reports",
    loginButton: "Sign in",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Password",
    noAccount: "No account yet?",
    createAccount: "Create one",
    registerTitle: "Create your account",
    registerSubtitle: "Start structuring your projects in minutes.",
    registerTag1: "Connected teams",
    registerTag2: "Ready templates",
    registerTag3: "Visible metrics",
    registerButton: "Create account",
    namePlaceholder: "Full name",
    organizationName: "Organization Name",
    organizationNamePlaceholder: "E.g.: My Company",
    confirmPassword: "Confirm password",
    alreadyHaveAccount: "Already have an account?",
    signInHere: "Sign in here",
    loginSuccess: "Signed in successfully",
    loginError: "Unable to sign in",
    registerSuccess: "Account created",
    registerError: "Unable to register, try again",
    passwordMismatch: "Passwords do not match",
    emailAlreadyExists: "This email is already registered",
    forgotPassword: "Forgot my password",
    forgotPasswordTitle: "Reset your password",
    forgotPasswordSubtitle: "We will send a secure link to your email.",
    sendResetLink: "Send reset link",
    backToLogin: "Back to login",
    resetEmailSent: "If the email exists, we will send a reset link",
    resetEmailError: "Error sending reset email",
    resetTitle: "Create a new password",
    resetSubtitle: "Set a secure password to continue.",
    resetButton: "Reset password",
    resetSuccess: "Password reset successfully",
    resetError: "Error resetting password",
    resetTokenMissing: "Reset token not found",
  },
  onboarding: {
    stepLabel: "Step {{step}} of {{total}}",
    welcome: "Let's finish your initial setup.",
    orgSetupTitle: "Set up your organization",
    orgSetupSubtitle: "Choose a clear name and a unique identifier.",
    orgSetupSuccess: "Organization updated successfully",
    orgSetupError: "Error updating organization",
    teamStep: "Invite your team (optional)",
    inviteTitle: "Invite collaborators",
    inviteSubtitle: "Add emails and we will send invites right away.",
    inviteEmailLabel: "Collaborator email",
    inviteEmailPlaceholder: "email@company.com",
    addInvite: "Add",
    inviteSuccess: "Invites sent successfully",
    inviteError: "Error sending invites",
    invalidEmail: "Invalid email",
    emailAlreadyAdded: "Email already added",
    projectStep: "Create your first project",
    projectTitle: "First project",
    projectSubtitle: "Create a project to organize your tests.",
    projectSuccess: "Project created successfully",
    projectError: "Error creating project",
    finishSetup: "Finish setup",
    skipStep: "Skip step",
    skipToDashboard: "Go to dashboard",
  },
  organization: {
    settings: "Settings",
    settingsDescription: "Manage your organization settings",
    members: "Members",
    membersDescription: "Manage your organization members",
    listTitle: "My organizations",
    listHelp: "Organizations you belong to or manage",
    searchLabel: "Search by name",
    searchPlaceholder: "Search by name...",
    loadingList: "Loading your organizations...",
    emptyList: "No organizations found",
    roleOwner: "Owner",
    roleAdmin: "Administrator",
    roleMember: "Member",
    name: "Organization Name",
    namePlaceholder: "E.g.: My Company",
    slug: "Identifier (Slug)",
    slugReadonly: "The identifier cannot be changed",
    plan: "Plan",
    createNew: "Create organization",
    createNewTitle: "Create organization",
    createSuccess: "Organization created successfully",
    createError: "Failed to create organization",
    limitReached: "Organization limit reached",
    updateSuccess: "Organization updated successfully",
    updateError: "Failed to update organization",
    noOrganization: "No organization selected",
    accessDenied: "You do not have permission to access this page",
    switchOrg: "Switch organization",
    switchError: "Unable to switch organization",
    loadMembersError: "Failed to load members",
    noMembers: "No members found",
    activeMembers: "Active members",
    memberName: "Name",
    memberEmail: "Email",
    memberRole: "Role",
    you: "you",
    editRole: "Edit role",
    removeMember: "Remove member",
    confirmRemove: "Are you sure you want to remove {{name}} from the organization?",
    memberRemoved: "Member removed successfully",
    removeError: "Failed to remove member",
    roleUpdated: "Role updated successfully",
    roleUpdateError: "Failed to update role",
    inviteMember: "Invite member",
    invite: "Invite",
    inviteEmail: "Invitee email",
    inviteRole: "Invitee role",
    sendInvite: "Send invite",
    inviteSent: "Invite sent successfully",
    inviteError: "Failed to send invite",
    inviteHint: "If the email already has an account, the user can accept the invite directly. Otherwise, an invitation email will be sent.",
    inviteCreatedUserExists: "Invite created! The user can accept it from the system.",
    inviteSentByEmail: "Invite sent by email!",
    pendingInvites: "Pending invites",
    invitedAt: "Invited at",
    expiresAt: "Expires at",
    resendInvite: "Resend invite",
    cancelInvite: "Cancel invite",
    confirmCancelInvite: "Are you sure you want to cancel the invite for {{email}}?",
    inviteCanceled: "Invite canceled successfully",
    cancelInviteError: "Failed to cancel invite",
    inviteResent: "Invite resent by email",
    inviteRefreshed: "Invite refreshed! The user can accept it from the system.",
    resendInviteError: "Failed to resend invite",
    myInvites: "My invites",
    noInvites: "You have no pending invites",
    acceptInvite: "Accept invite",
    declineInvite: "Decline invite",
    inviteFrom: "Invite from",
    inviteAccepted: "Invite accepted successfully!",
    acceptInviteError: "Failed to accept invite",
    viewInvites: "View invites",
  },
  admin: {
    accessDenied: "Access denied. Administrator permission required.",
    billingPlans: "Billing Plans",
    billingPlansSubtitle: "Manage billing plans stored in the database. You can sync from Stripe and configure limits and features.",
    plansList: "Registered plans",
    noPlans: "No plans found. Sync from Stripe to import.",
    syncFromStripe: "Sync from Stripe",
    syncSuccess: "{{count}} plan(s) synced successfully",
    syncError: "Failed to sync plans from Stripe",
    loadError: "Failed to load plans",
    editPlan: "Edit plan",
    planName: "Name",
    planPrice: "Price (cents)",
    pricePlaceholder: "E.g.: 9900 for $99.00",
    priceHint: "Value in cents. Leave empty for free.",
    planActive: "Status",
    active: "Active",
    inactive: "Inactive",
    configured: "Configured",
    notConfigured: "Not configured",
    enabled: "Enabled",
    disabled: "Disabled",
    unlimited: "Unlimited",
    limitsTitle: "Limits",
    limitsHint: "Leave empty for unlimited.",
    limitsSeats: "Seats",
    limitsProjects: "Projects",
    limitsTestCases: "Test cases",
    limitsStorage: "Storage (bytes)",
    limitsExecutions: "Executions",
    featuresTitle: "Features",
    featuresApiAccess: "API Access",
    featuresWebhooks: "Webhooks",
    featuresAuditLogs: "Audit logs (days)",
    days: "{{count}} days",
    nameRequired: "Name is required",
    saveSuccess: "Plan updated successfully",
    saveError: "Failed to save plan",
    subscriptions: "Subscriptions",
    subscriptionsSubtitle: "Manage organization subscriptions. You can view and change each organization's plan.",
    subscriptionsList: "Subscriptions",
    noSubscriptions: "No subscriptions found.",
    searchOrg: "Search organization...",
    changePlan: "Change plan",
    currentPlan: "Current plan",
    newPlan: "New plan",
    planChangeSuccess: "Plan changed successfully",
    planChangeError: "Failed to change plan",
    periodStart: "Start",
    periodEnd: "End",
    cancelsAtEnd: "Cancels at period end",
  },
};

export default en;
